import * as React from "react";
import { Icon } from "../frame/Icon.jsx";
import * as cls from "./Section.module.scss";
export { Section };
/**
 * Секция основного содержимого с заголовком и иконкой.
 * @param {Object} props - Атрибуты элемента.
 * @param {string} props.icon - Имя иконки.
 * @param {React.ReactNode} props.title - Заголовок секции.
 * @param {JSX.Element} props.children - Содержимое.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * <Section icon="question" title="Заголовок секции">Содержимое</Section>
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function Section(
  {
    icon = "question",
    title = "Section.title",
    header, // Отлавливаем ошибки после переименования `header` => `title`
    children
  }) {
  if (header) {
    console.error("Section: header вместо title");
    title = header;
  }
  return (
    <section className={cls.section}>
      <h2>
        <span className={cls.section_icon}>
          <Icon name={icon} />
        </span>
        {title}
      </h2>
      {children}
    </section>
  );
}
